import React from 'react';
import { Link } from 'react-router-dom';
import styles from './AppPage.module.css';
import beatClickerIcon from '../assets/beatclicker-icon.jpg';

function BeatClickerPage() {
  return (
    <div className={styles.appPage}>
      <div className={`${styles.appHero} ${styles.beatClickerHero}`}>
        <div className={styles.heroContent}>
          <img src={beatClickerIcon} alt="Beat Clicker" className={styles.appIconImg} />
          <h1>Beat Clicker</h1>
          <span className={styles.status}>READY TO LAUNCH</span>
          <p className={styles.tagline}>
            One button. Endless sequences. Pure brain-stimulating fun.
          </p>
        </div>
      </div>

      <section className={styles.section}>
        <h2>Simple by Design</h2>
        <p>
          In a world of overly complex games with tutorials, currencies, and endless menus,
          Beat Clicker strips everything away. One button. Listen to the sequence. Tap it back.
          That's it. No ads interrupting your flow. No complexity. Just you and the beat.
        </p>
      </section>

      <section className={styles.section}>
        <h2>How It Works</h2>
        <div className={styles.steps}>
          <div className={styles.step}>
            <span className={styles.stepNumber}>1</span>
            <h3>Listen</h3>
            <p>The app plays a sequence of beats</p>
          </div>
          <div className={styles.step}>
            <span className={styles.stepNumber}>2</span>
            <h3>Remember</h3>
            <p>Concentrate on the pattern and timing</p>
          </div>
          <div className={styles.step}>
            <span className={styles.stepNumber}>3</span>
            <h3>Tap</h3>
            <p>Replicate the sequence by tapping</p>
          </div>
          <div className={styles.step}>
            <span className={styles.stepNumber}>4</span>
            <h3>Progress</h3>
            <p>Sequences get longer and more complex</p>
          </div>
        </div>
      </section>

      <section className={styles.section}>
        <h2>Key Features</h2>
        <ul className={styles.featureList}>
          <li>
            <strong>One-Button Gameplay</strong>
            <span>No complicated controls—just tap</span>
          </li>
          <li>
            <strong>Memory Training</strong>
            <span>Exercises your working memory and concentration</span>
          </li>
          <li>
            <strong>Completely Ad-Free</strong>
            <span>No interruptions, ever</span>
          </li>
          <li>
            <strong>Button Skins</strong>
            <span>Unlock new looks with in-game credits and XP</span>
          </li>
          <li>
            <strong>Premium Skins</strong>
            <span>Optional premium skins for those who want more</span>
          </li>
          <li>
            <strong>Relaxing Experience</strong>
            <span>Calming yet mentally engaging</span>
          </li>
        </ul>
      </section>

      <section className={styles.section}>
        <h2>Benefits</h2>
        <div className={styles.useCards}>
          <div className={styles.useCard}>
            <h3>Sharpen Focus</h3>
            <p>Train your brain to concentrate on patterns</p>
          </div>
          <div className={styles.useCard}>
            <h3>Improve Memory</h3>
            <p>Challenge your working memory daily</p>
          </div>
          <div className={styles.useCard}>
            <h3>Unwind</h3>
            <p>A meditative break from screen chaos</p>
          </div>
        </div>
      </section>

      <section className={styles.ctaSection}>
        <h2>Coming Soon</h2>
        <p>Beat Clicker is ready to launch. Be the first to know when it's available.</p>
        <div className={styles.storeButtons}>
          <button className={styles.storeButton} disabled>
            <span className={styles.storeName}>App Store</span>
            <span className={styles.storeStatus}>Coming Soon</span>
          </button>
          <button className={styles.storeButton} disabled>
            <span className={styles.storeName}>Google Play</span>
            <span className={styles.storeStatus}>Coming Soon</span>
          </button>
        </div>
      </section>

      <div className={styles.backLink}>
        <Link to="/">← Back to Home</Link>
      </div>
    </div>
  );
}

export default BeatClickerPage;
